import { useAtomValue } from 'jotai'
import React from 'react'

import { Box } from '~/components/elements/Box'
import { VStack } from '~/components/elements/VStack'
import { exists } from '~/utils'

import { tabulationQueryDataAtom } from '../../atoms'
import { indicatorGroups } from '../../utils'

import { DistributionCharts } from './DistributionCharts'
import { GroupContent } from './GroupContent'

export type TimeSeriesAnalysisBodyProps = {
  className?: string
}

export const TimeSeriesAnalysisBody = ({
  className,
}: TimeSeriesAnalysisBodyProps) => {
  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)

  return (
    <Box className={className} padding={2}>
      {exists(tabulationQueryData) && (
        <VStack spacing={2} verticalAppearance="stretch-scroll">
          <DistributionCharts />

          {indicatorGroups.map((indicatorGroup) => (
            <GroupContent
              key={indicatorGroup}
              indicatorGroup={indicatorGroup}
            />
          ))}
        </VStack>
      )}
    </Box>
  )
}
